module.exports = __webpack_public_path__ + "img/nutriteev.81625c84.svg";